import { render, staticRenderFns } from "./TelemetriesDatatable.vue?vue&type=template&id=28c2aace"
import script from "./TelemetriesDatatable.vue?vue&type=script&lang=js"
export * from "./TelemetriesDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports